<script lang="ts">
	import Icon from "./Icon.svelte";
	import downloadIcon from "../../../core/assets/icons/download-outlined.svg?raw";
	import type { Document } from "../../../core/schema/Document.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let document: Document;

	const { STORAGE_URL } = getGlobalSettings();
</script>

<a
	href="{STORAGE_URL}/{document.attachment.path}"
	download
	target="_blank"
	class="hover:bg-tertiary-100 border-tertiary flex items-center justify-between gap-6 border-b-2 p-11 transition-all duration-200 last:border-0"
>
	<div class="flex flex-col gap-10">
		<span class="lg:text-2md text-[1.125rem] font-bold">{nbspify(document.name)}</span>
		{#if document.description}
			<span class="text-[1.125rem] lg:text-[1.1875rem]">{nbspify(document.description)}</span>
		{/if}
	</div>
	<Icon icon={downloadIcon} class="text-primary w-[3.75rem]" />
</a>
